import { LanguageInterface } from '@/types/translations';
import Axios from 'axios';


class LanguageService {
  public fetchAll(): Promise<LanguageInterface[]> {
    return new Promise((resolve, reject) => {
      Axios.get('/languages?enabled-only=true')
        .then((response) => resolve(response.data))
        .catch(reject);
    });
  }
}

export default new LanguageService();
